/**
 * TreeMapFilters Component
 *
 * Filter controls for the tree map
 */

import React from 'react';
import type { TreeMapFiltersProps } from '../../organisms/TreeMap/types';
import './TreeMapFilters.scss';

const TreeMapFilters: React.FC<TreeMapFiltersProps> = ({
  filters,
  onChange,
  availableOwners,
  availableStatuses,
  schemas,
}) => {
  return (
    <div className="tree-map-filters">
      <div className="tree-map-filters__controls">
        <div className="tree-map-filters__group">
          <label htmlFor="tree-map-filters-owner">Owner</label>
          {/* Multi-select dropdown not yet implemented */}
          <p id="tree-map-filters-owner" className="text-muted">Filter by owner (coming soon)</p>
        </div>

        <div className="tree-map-filters__group">
          <label htmlFor="tree-map-filters-status">Status</label>
          {/* Multi-select dropdown not yet implemented */}
          <p id="tree-map-filters-status" className="text-muted">Filter by status (coming soon)</p>
        </div>

        <div className="tree-map-filters__group">
          <label htmlFor="tree-map-filters-search">Search</label>
          <input
            id="tree-map-filters-search"
            type="text"
            placeholder="Search spheres..."
            value={filters.search || ''}
            onChange={(e) => onChange({ ...filters, search: e.target.value })}
          />
        </div>
      </div>

      {(filters.owners.length > 0 || filters.statuses.length > 0 || filters.search) && (
        <div className="tree-map-filters__active">
          <span>Active filters: </span>
          <button onClick={() => onChange({ owners: [], statuses: [], schemaTypes: [] })}>
            Clear all
          </button>
        </div>
      )}
    </div>
  );
};

export default TreeMapFilters;
